import { createContext, useContext, useEffect, useMemo, useState } from "react";

const STRINGS = {
  en: {
    nav_home: "Home",
    nav_estimator: "Estimator",
    nav_devices: "Devices",
    nav_admin: "Login",
    nav_get_estimate: "Get Estimate",
    hero_overline: "Estimator + Promo Browser",
    hero_h1_a: "Total Wireless",
    hero_h1_b: "pricing,",
    hero_h1_c: "decoded.",
    hero_body: "Build a transparent monthly bill estimate in seconds. Browse live device promotions. Save and share quotes with a single link.",
    cta_start_estimator: "Start Estimator",
    cta_browse_devices: "Browse Devices",
    stat_plans: "Plans",
    stat_promos: "Promos",
    stat_devices: "Devices",
    sample_total: "Sample monthly total",
    as_of_today: "As of today",
    feature_math_t: "Side-by-side math",
    feature_math_d: "See exactly how plan + lines + add-ons add up. No surprises.",
    feature_promo_t: "Promo aware",
    feature_promo_d: "Auto-surfaces active device promotions and eligibility.",
    feature_save_t: "Save & share",
    feature_save_d: "Generate a clean shareable quote link or printable PDF.",
    promos_overline: "Device Promotions",
    promos_title: "Active offers right now",
    promos_see_all: "See all devices",
    promos_empty: "No promos yet. Sign in to admin to add the first one.",
    promos_admin_login: "Admin Login",
    cta_banner_overline: "Ready when you are",
    cta_banner_title_a: "Calculate your",
    cta_banner_title_b: "monthly bill",
    cta_banner_title_c: "in 60 seconds.",
    cta_open_estimator: "Open Estimator",

    estimator_overline: "Bill Estimator",
    estimator_title: "Build your monthly bill",
    estimator_subtitle: "Pick a plan, choose lines, add features. Your live quote updates on the right.",
    step_1_title: "Choose a plan",
    step_2_title: "How many lines?",
    step_2_body: "Multi-line discount applies to each additional line based on the selected plan.",
    step_3_title: "Add-ons",
    step_4_title: "Customer details (optional)",
    field_name: "Name",
    field_email: "Email",
    field_email_note: "Saved with the quote; no email is sent.",
    wizard_back: "Back",
    wizard_next: "Next",
    wizard_save: "Save & Share Quote",
    live_quote: "Live Quote",
    select_plan_prompt: "Select a plan to begin",
    base_plan: "Base plan",
    subtotal: "Subtotal",
    taxes_fees_est: "Est. taxes & fees",
    total_month: "Total / month",
    total_monthly_est: "Total monthly · est.",
    no_plans_t: "No plans configured yet.",
    no_plans_d: "Sign in to the admin panel and add at least one plan.",
    unlimited: "Unlimited",

    devices_overline: "Device Catalog",
    devices_h1_a: "Phones",
    devices_h1_b: "+ promos",
    devices_subtitle: "Browse the active device lineup. Promotions are auto-tagged on each card.",
    devices_search_ph: "Search by brand or model",
    devices_filter_all: "All",
    devices_empty: "No devices match your filter.",
    back_to_devices: "Back to devices",
    msrp: "MSRP",
    active_promos: "Active promotions",
    device_promos_empty: "No active promotions for this device right now.",
    new_line_required: "New line required",
    port_in_required: "Port-in required",
    min_plan: "Min plan",
    ends: "Ends",
    build_my_plan: "Build my plan",

    quote_summary: "Quote Summary",
    quote_h1: "TW Calc — Monthly bill estimate",
    quote_bill_to: "Bill to",
    plan: "Plan",
    line: "line",
    lines: "lines",
    charges: "Charges",
    saved_shareable: "Saved & shareable",
    quote_disclaimer: "Estimate generated by TW Calc. Taxes & surcharges vary by location. Not affiliated with Total Wireless, TracFone, or Verizon.",
    new_estimate: "New estimate",
    share: "Share",
    pdf: "PDF",
    print: "Print",

    admin_panel: "Admin Panel",
    sign_in: "Sign in",
    admin_only: "Admin access only.",
    language: "Language",
  },
  es: {
    nav_home: "Inicio",
    nav_estimator: "Estimador",
    nav_devices: "Equipos",
    nav_admin: "Administrador",
    nav_get_estimate: "Cotizar ahora",
    hero_overline: "Estimador + Catálogo de promos",
    hero_h1_a: "Precios de Total Wireless,",
    hero_h1_b: "claros",
    hero_h1_c: "y al instante.",
    hero_body: "Calcula tu factura mensual en segundos. Explora promociones de equipos activas. Guarda y comparte cotizaciones con un solo enlace.",
    cta_start_estimator: "Comenzar estimación",
    cta_browse_devices: "Ver equipos",
    stat_plans: "Planes",
    stat_promos: "Promos",
    stat_devices: "Equipos",
    sample_total: "Total mensual de muestra",
    as_of_today: "Al día de hoy",
    feature_math_t: "Cálculo transparente",
    feature_math_d: "Ve exactamente cómo se suman plan + líneas + extras. Sin sorpresas.",
    feature_promo_t: "Con promos",
    feature_promo_d: "Muestra automáticamente promociones activas y elegibilidad.",
    feature_save_t: "Guarda y comparte",
    feature_save_d: "Genera un enlace o PDF imprimible de la cotización.",
    promos_overline: "Promociones de equipos",
    promos_title: "Ofertas activas ahora mismo",
    promos_see_all: "Ver todos los equipos",
    promos_empty: "Aún no hay promos. Inicia sesión como admin para agregar la primera.",
    promos_admin_login: "Inicio admin",
    cta_banner_overline: "Cuando estés listo",
    cta_banner_title_a: "Calcula tu",
    cta_banner_title_b: "factura mensual",
    cta_banner_title_c: "en 60 segundos.",
    cta_open_estimator: "Abrir estimador",

    estimator_overline: "Estimador",
    estimator_title: "Arma tu factura mensual",
    estimator_subtitle: "Elige un plan, define líneas y extras. Tu cotización se actualiza a la derecha.",
    step_1_title: "Elige un plan",
    step_2_title: "¿Cuántas líneas?",
    step_2_body: "El descuento por líneas adicionales aplica según el plan elegido.",
    step_3_title: "Extras",
    step_4_title: "Datos del cliente (opcional)",
    field_name: "Nombre",
    field_email: "Correo",
    field_email_note: "Se guarda con la cotización; no se envía correo.",
    wizard_back: "Atrás",
    wizard_next: "Siguiente",
    wizard_save: "Guardar y compartir",
    live_quote: "Cotización en vivo",
    select_plan_prompt: "Elige un plan para comenzar",
    base_plan: "Plan base",
    subtotal: "Subtotal",
    taxes_fees_est: "Impuestos y cargos (est.)",
    total_month: "Total / mes",
    total_monthly_est: "Total mensual · est.",
    no_plans_t: "Aún no hay planes configurados.",
    no_plans_d: "Inicia sesión como admin y agrega al menos un plan.",
    unlimited: "Ilimitado",

    devices_overline: "Catálogo de equipos",
    devices_h1_a: "Teléfonos",
    devices_h1_b: "+ promos",
    devices_subtitle: "Explora los equipos disponibles. Las promociones se muestran en cada tarjeta.",
    devices_search_ph: "Buscar por marca o modelo",
    devices_filter_all: "Todos",
    devices_empty: "Ningún equipo coincide con tu filtro.",
    back_to_devices: "Volver a equipos",
    msrp: "Precio sugerido",
    active_promos: "Promociones activas",
    device_promos_empty: "No hay promociones activas para este equipo.",
    new_line_required: "Requiere línea nueva",
    port_in_required: "Requiere portabilidad",
    min_plan: "Plan mínimo",
    ends: "Termina",
    build_my_plan: "Armar mi plan",

    quote_summary: "Resumen de cotización",
    quote_h1: "TW Calc — Estimación mensual",
    quote_bill_to: "Cliente",
    plan: "Plan",
    line: "línea",
    lines: "líneas",
    charges: "Cargos",
    saved_shareable: "Guardada y compartible",
    quote_disclaimer: "Estimación generada por TW Calc. Impuestos y cargos varían por ubicación. No afiliado a Total Wireless, TracFone o Verizon.",
    new_estimate: "Nueva estimación",
    share: "Compartir",
    pdf: "PDF",
    print: "Imprimir",

    admin_panel: "Panel admin",
    sign_in: "Iniciar sesión",
    admin_only: "Solo administradores.",
    language: "Idioma",
  },
  ar: {
    nav_home: "الرئيسية",
    nav_estimator: "حاسبة الفاتورة",
    nav_devices: "الأجهزة",
    nav_admin: "المسؤول",
    nav_get_estimate: "احصل على تقدير",
    hero_overline: "حاسبة الفاتورة + كتالوج العروض",
    hero_h1_a: "أسعار",
    hero_h1_b: "توتال وايرلس",
    hero_h1_c: "بوضوح تام.",
    hero_body: "أنشئ تقدير فاتورة شهرية شفافًا في ثوانٍ. تصفّح عروض الأجهزة النشطة. احفظ وشارك العروض برابط واحد.",
    cta_start_estimator: "ابدأ التقدير",
    cta_browse_devices: "تصفّح الأجهزة",
    stat_plans: "الباقات",
    stat_promos: "العروض",
    stat_devices: "الأجهزة",
    sample_total: "إجمالي شهري نموذجي",
    as_of_today: "حتى اليوم",
    feature_math_t: "حساب شفّاف",
    feature_math_d: "شاهد بالتفصيل كيف تُجمع الباقة + الخطوط + الإضافات. بلا مفاجآت.",
    feature_promo_t: "يضم العروض",
    feature_promo_d: "يُبرز العروض النشطة وشروط الاستفادة تلقائيًا.",
    feature_save_t: "احفظ وشارك",
    feature_save_d: "أنشئ رابطًا أو ملف PDF نظيفًا للعرض السعري.",
    promos_overline: "عروض الأجهزة",
    promos_title: "عروض نشطة الآن",
    promos_see_all: "عرض كل الأجهزة",
    promos_empty: "لا توجد عروض بعد. سجّل الدخول كمسؤول لإضافة أول عرض.",
    promos_admin_login: "دخول المسؤول",
    cta_banner_overline: "متى ما كنت جاهزًا",
    cta_banner_title_a: "احسب",
    cta_banner_title_b: "فاتورتك الشهرية",
    cta_banner_title_c: "في 60 ثانية.",
    cta_open_estimator: "فتح الحاسبة",

    estimator_overline: "حاسبة الفاتورة",
    estimator_title: "كوّن فاتورتك الشهرية",
    estimator_subtitle: "اختر باقة وعدد الخطوط والإضافات. يتحدث ملخّص العرض على اليسار مباشرةً.",
    step_1_title: "اختر باقة",
    step_2_title: "كم عدد الخطوط؟",
    step_2_body: "يُطبَّق خصم الخطوط الإضافية لكل خط إضافي حسب الباقة المختارة.",
    step_3_title: "الإضافات",
    step_4_title: "بيانات العميل (اختياري)",
    field_name: "الاسم",
    field_email: "البريد الإلكتروني",
    field_email_note: "يُحفظ مع العرض؛ لا يُرسَل أي بريد.",
    wizard_back: "السابق",
    wizard_next: "التالي",
    wizard_save: "حفظ ومشاركة",
    live_quote: "ملخّص مباشر",
    select_plan_prompt: "اختر باقة للبدء",
    base_plan: "الباقة الأساسية",
    subtotal: "المجموع الفرعي",
    taxes_fees_est: "الضرائب والرسوم (تقديري)",
    total_month: "الإجمالي / شهريًا",
    total_monthly_est: "إجمالي شهري · تقديري",
    no_plans_t: "لا توجد باقات معدّة بعد.",
    no_plans_d: "سجّل الدخول إلى لوحة المسؤول وأضف باقة واحدة على الأقل.",
    unlimited: "غير محدودة",

    devices_overline: "كتالوج الأجهزة",
    devices_h1_a: "الهواتف",
    devices_h1_b: "+ العروض",
    devices_subtitle: "تصفّح الأجهزة المتاحة. تظهر العروض موسومة على كل بطاقة.",
    devices_search_ph: "ابحث بالعلامة أو الموديل",
    devices_filter_all: "الكل",
    devices_empty: "لا توجد أجهزة مطابقة لتصفيتك.",
    back_to_devices: "العودة إلى الأجهزة",
    msrp: "السعر المقترح",
    active_promos: "العروض النشطة",
    device_promos_empty: "لا توجد عروض نشطة لهذا الجهاز حاليًا.",
    new_line_required: "يتطلّب خطًا جديدًا",
    port_in_required: "يتطلّب نقل رقم",
    min_plan: "حد أدنى للباقة",
    ends: "ينتهي",
    build_my_plan: "بناء باقتي",

    quote_summary: "ملخّص العرض",
    quote_h1: "TW Calc — تقدير الفاتورة الشهرية",
    quote_bill_to: "العميل",
    plan: "الباقة",
    line: "خط",
    lines: "خطوط",
    charges: "الرسوم",
    saved_shareable: "محفوظ وقابل للمشاركة",
    quote_disclaimer: "تقدير تم توليده بواسطة TW Calc. تختلف الضرائب والرسوم حسب الموقع. غير تابعة لشركة Total Wireless أو TracFone أو Verizon.",
    new_estimate: "تقدير جديد",
    share: "مشاركة",
    pdf: "PDF",
    print: "طباعة",

    admin_panel: "لوحة المسؤول",
    sign_in: "تسجيل الدخول",
    admin_only: "للمسؤولين فقط.",
    language: "اللغة",
  },
};

const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "ar", label: "العربية", short: "AR" },
];

const RTL_LANGS = new Set(["ar"]);

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k, langs: LANGS });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tw_lang") || "en");
  useEffect(() => {
    localStorage.setItem("tw_lang", lang);
    const isRtl = RTL_LANGS.has(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
  }, [lang]);
  const value = useMemo(() => ({
    lang,
    setLang,
    langs: LANGS,
    t: (k) => (STRINGS[lang] && STRINGS[lang][k]) || STRINGS.en[k] || k,
  }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useT() { return useContext(LangContext); }
